
import { defineComponent, PropType, ref } from 'vue'
import MembersEditMemberPhoneForm from '@/components/members/forms/edit-member-phone.vue'
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';
import { Phone } from '@/modules/members'

export default defineComponent({
    name: 'members-edit-member-phone-dialog',
    components: {
        MembersEditMemberPhoneForm
    },
    props: {
        organizationId: {
            type: String
        },
        memberId: {
            type: String
        },
        phone: {
            type: Object as PropType<Phone>
        },
        updateCallback: {
            type: Function as PropType<(t: Phone) => void>,
            required: true
        }
    },
    emits: [...useDialogPluginComponent.emits],
    setup (props) {
        const { dialogRef, onDialogHide, onDialogCancel } = useDialogPluginComponent()

        const phoneModel = ref(props.phone)

        return {
            dialogRef,
            onDialogHide,
            onCancelClick: onDialogCancel,
            phoneModel
        }
    }
})
